import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Modal, Image, Button, Offcanvas, OverlayTrigger, Tooltip } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  constructor(props) {
    super(props)

    this.state = {
      variant: null
    }
  }

  priceFormat(price, delimiter, fraction) {
    fraction = [0,1,2].indexOf(fraction) !== -1 ? fraction : 0
    delimiter = delimiter || ' '
    price = (price = parseFloat(price)) && isFinite(price) && price.toFixed(fraction) || false
    if (price === false) throw new TypeError('Price should be a valid integer.')
    var reverseString = function(string) {
        return string.split('').reverse().join('')
    }
    return reverseString(reverseString(price).replace(/(\d{3})/g, '$&' + delimiter))
  }

  setVariant = ( id ) => {
    const { in_cart } = this.props
    if(in_cart.variants != null) {
      in_cart.variants.map(( elm ) => {
        if( elm.id == id ) {
          this.setState({
            variant: elm
          })
        }
      })
    }
  }

  addTocart = () => {
    const { in_cart, addTocart } = this.props,
    { variant } = this.state

    if(variant != null) {
      addTocart({
        resource: in_cart.res_id,
        product: variant.product,
        variant: variant.id,
        count: 1
      })
    } else {
      addTocart({
        resource: in_cart.res_id,
        product: in_cart.id,
        variant: null,
        count: 1
      })
    }
  }

  componentDidUpdate( prevProps ) {
    const { in_cart, in_cart_show } = this.props
    if (prevProps.in_cart_show !== in_cart_show && in_cart_show) {
      if(in_cart.variants != null) this.setVariant( in_cart.variants[0].id )
    }
  }

  render() {

    const { in_cart_show, in_cart, closeInCart, clientWidth } = this.props,
    { variant } = this.state,
    u_sizes = [], u_colors = []

    const cart_body = (
      <>
        {in_cart.variants == null ?
          <>
            <Image className={styles.tocart_image} src={in_cart.image} width={126} height={208} />
            <div style={{ flex: 1 }}>
              <div className='d-flex align-items-start justify-content-between'>
                <div className={styles.tocart_art}>Арт. {in_cart.article}</div>
                {in_cart.price > 0 &&
                  <div className={styles.tocart_price}>{this.priceFormat(in_cart.price)} ₽</div>
                }
              </div>
              <div className={styles.tocart_name}>{in_cart.name}</div>
              <div className={styles.tocart_buttons}>
                {in_cart.stock > 0 ?
                  <Button onClick={() => this.addTocart()} className='d-flex justify-content-between align-items-center' variant='primary'>
                    <div>В корзину</div>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.0731 14.9325C13.9637 14.9325 13.0643 15.8318 13.0643 16.9412C13.0643 18.0506 13.9637 18.95 15.0731 18.95C16.1825 18.95 17.0818 18.0506 17.0818 16.9412C17.0818 15.8318 16.1825 14.9325 15.0731 14.9325ZM15.0731 14.9325H7.33325C6.87017 14.9325 6.6382 14.9325 6.44755 14.8501C6.27936 14.7774 6.13345 14.6604 6.02714 14.5112C5.90799 14.3439 5.86006 14.1202 5.7652 13.6775L3.29316 2.14128C3.19609 1.68829 3.1469 1.46205 3.02637 1.29286C2.92006 1.14363 2.77418 1.02618 2.60599 0.953502C2.4153 0.871094 2.18463 0.871094 1.72135 0.871094H1.01172M4.02487 3.88424H16.9545C17.6794 3.88424 18.0416 3.88424 18.2849 4.03526C18.498 4.16754 18.654 4.375 18.722 4.61644C18.7997 4.89207 18.6999 5.24012 18.499 5.93666L17.1083 10.7577C16.9882 11.1742 16.9281 11.382 16.8062 11.5365C16.6987 11.6729 16.5568 11.7797 16.3959 11.8453C16.2142 11.9193 15.9982 11.9193 15.5673 11.9193H5.76292M6.03363 18.95C4.92422 18.95 4.02487 18.0506 4.02487 16.9412C4.02487 15.8318 4.92422 14.9325 6.03363 14.9325C7.14304 14.9325 8.0424 15.8318 8.0424 16.9412C8.0424 18.0506 7.14304 18.95 6.03363 18.95Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </Button>
                :
                  <OverlayTrigger overlay={<Tooltip id={`color_overlay_incart_stock`}>Нет в наличии</Tooltip>}>
                    <Button className={styles.tocart_btn_stock + ' d-flex justify-content-between align-items-center'} variant='primary'>
                      <div>В корзину</div>
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M15.0731 14.9325C13.9637 14.9325 13.0643 15.8318 13.0643 16.9412C13.0643 18.0506 13.9637 18.95 15.0731 18.95C16.1825 18.95 17.0818 18.0506 17.0818 16.9412C17.0818 15.8318 16.1825 14.9325 15.0731 14.9325ZM15.0731 14.9325H7.33325C6.87017 14.9325 6.6382 14.9325 6.44755 14.8501C6.27936 14.7774 6.13345 14.6604 6.02714 14.5112C5.90799 14.3439 5.86006 14.1202 5.7652 13.6775L3.29316 2.14128C3.19609 1.68829 3.1469 1.46205 3.02637 1.29286C2.92006 1.14363 2.77418 1.02618 2.60599 0.953502C2.4153 0.871094 2.18463 0.871094 1.72135 0.871094H1.01172M4.02487 3.88424H16.9545C17.6794 3.88424 18.0416 3.88424 18.2849 4.03526C18.498 4.16754 18.654 4.375 18.722 4.61644C18.7997 4.89207 18.6999 5.24012 18.499 5.93666L17.1083 10.7577C16.9882 11.1742 16.9281 11.382 16.8062 11.5365C16.6987 11.6729 16.5568 11.7797 16.3959 11.8453C16.2142 11.9193 15.9982 11.9193 15.5673 11.9193H5.76292M6.03363 18.95C4.92422 18.95 4.02487 18.0506 4.02487 16.9412C4.02487 15.8318 4.92422 14.9325 6.03363 14.9325C7.14304 14.9325 8.0424 15.8318 8.0424 16.9412C8.0424 18.0506 7.14304 18.95 6.03363 18.95Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                    </Button>
                  </OverlayTrigger>
                }
                <Button onClick={closeInCart} variant='info'>Закрыть</Button>
              </div>
            </div>
          </>
        :
          <>
            {variant != null &&
              <>
                <Image className={styles.tocart_image} src={variant.image} width={126} height={208} />
                <div style={{ flex: 1 }}>
                  <div className='d-flex align-items-start justify-content-between'>
                    <div className={styles.tocart_art}>Арт. {in_cart.article}</div>
                    {variant.price > 0 &&
                      <div className={styles.tocart_price}>{this.priceFormat(variant.price)} ₽</div>
                    }
                  </div>
                  <div className={styles.tocart_name}>{variant.name}</div>
                  <div className={styles.tocart_opt_title}>Выберите размер</div>
                  <div className={styles.tocart_opt_list}>
                    {in_cart.variants.sort( (a, b) => {
                        return Number(a.size) - Number(b.size)
                    }).map(( elm, i ) => {
                      if(!u_sizes.includes( elm.size )) {
                        u_sizes.push( elm.size )
                        var stock = 0
                        in_cart.variants.map(( selm ) => {
                          if( selm.size == elm.size ) stock+= selm.stock
                        })
                        if( stock > 0) return (
                          <div onClick={() => this.setVariant( elm.id )} className={elm.size == variant.size ? styles.tocart_opt_size_active : styles.tocart_opt_size} key={i}>{elm.size == '' ? `NS` : elm.size}</div>
                        )
                        return (
                          <div onClick={() => this.setVariant( elm.id )} className={elm.size == variant.size ? styles.tocart_opt_size_active : styles.tocart_opt_size_empty} key={i}>{elm.size == '' ? `NS` : elm.size}</div>
                        )
                      }
                    })}
                  </div>
                  <div className={styles.tocart_opt_title}>Выберите цвет</div>
                  <div className={styles.tocart_opt_list}>
                  {in_cart.variants.map(( elm, i ) => {
                    if(variant.size == elm.size) {
                      if(!u_colors.includes( elm.colorName )) {
                        u_colors.push( elm.colorName )
                        return (
                          <OverlayTrigger key={i} overlay={<Tooltip id={`color_overlay_incart_` + elm.id + `_` + i}>{elm.colorName}</Tooltip>}>
                            <div onClick={() => this.setVariant( elm.id )} style={{ backgroundColor: elm.color }} className={styles.tocart_opt_color}></div>
                          </OverlayTrigger>
                        )
                      }
                    }
                  })}
                  </div>
                  <div className={styles.tocart_buttons}>
                    {variant.stock > 0 ?
                      <Button onClick={() => this.addTocart()} className='d-flex justify-content-between align-items-center' variant='primary'>
                        <div>В корзину</div>
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M15.0731 14.9325C13.9637 14.9325 13.0643 15.8318 13.0643 16.9412C13.0643 18.0506 13.9637 18.95 15.0731 18.95C16.1825 18.95 17.0818 18.0506 17.0818 16.9412C17.0818 15.8318 16.1825 14.9325 15.0731 14.9325ZM15.0731 14.9325H7.33325C6.87017 14.9325 6.6382 14.9325 6.44755 14.8501C6.27936 14.7774 6.13345 14.6604 6.02714 14.5112C5.90799 14.3439 5.86006 14.1202 5.7652 13.6775L3.29316 2.14128C3.19609 1.68829 3.1469 1.46205 3.02637 1.29286C2.92006 1.14363 2.77418 1.02618 2.60599 0.953502C2.4153 0.871094 2.18463 0.871094 1.72135 0.871094H1.01172M4.02487 3.88424H16.9545C17.6794 3.88424 18.0416 3.88424 18.2849 4.03526C18.498 4.16754 18.654 4.375 18.722 4.61644C18.7997 4.89207 18.6999 5.24012 18.499 5.93666L17.1083 10.7577C16.9882 11.1742 16.9281 11.382 16.8062 11.5365C16.6987 11.6729 16.5568 11.7797 16.3959 11.8453C16.2142 11.9193 15.9982 11.9193 15.5673 11.9193H5.76292M6.03363 18.95C4.92422 18.95 4.02487 18.0506 4.02487 16.9412C4.02487 15.8318 4.92422 14.9325 6.03363 14.9325C7.14304 14.9325 8.0424 15.8318 8.0424 16.9412C8.0424 18.0506 7.14304 18.95 6.03363 18.95Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </Button>
                    :
                      <OverlayTrigger overlay={<Tooltip id={`color_overlay_incart_stock`}>Нет в наличии</Tooltip>}>
                        <Button className={styles.tocart_btn_stock + ' d-flex justify-content-between align-items-center'} variant='primary'>
                          <div>В корзину</div>
                          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.0731 14.9325C13.9637 14.9325 13.0643 15.8318 13.0643 16.9412C13.0643 18.0506 13.9637 18.95 15.0731 18.95C16.1825 18.95 17.0818 18.0506 17.0818 16.9412C17.0818 15.8318 16.1825 14.9325 15.0731 14.9325ZM15.0731 14.9325H7.33325C6.87017 14.9325 6.6382 14.9325 6.44755 14.8501C6.27936 14.7774 6.13345 14.6604 6.02714 14.5112C5.90799 14.3439 5.86006 14.1202 5.7652 13.6775L3.29316 2.14128C3.19609 1.68829 3.1469 1.46205 3.02637 1.29286C2.92006 1.14363 2.77418 1.02618 2.60599 0.953502C2.4153 0.871094 2.18463 0.871094 1.72135 0.871094H1.01172M4.02487 3.88424H16.9545C17.6794 3.88424 18.0416 3.88424 18.2849 4.03526C18.498 4.16754 18.654 4.375 18.722 4.61644C18.7997 4.89207 18.6999 5.24012 18.499 5.93666L17.1083 10.7577C16.9882 11.1742 16.9281 11.382 16.8062 11.5365C16.6987 11.6729 16.5568 11.7797 16.3959 11.8453C16.2142 11.9193 15.9982 11.9193 15.5673 11.9193H5.76292M6.03363 18.95C4.92422 18.95 4.02487 18.0506 4.02487 16.9412C4.02487 15.8318 4.92422 14.9325 6.03363 14.9325C7.14304 14.9325 8.0424 15.8318 8.0424 16.9412C8.0424 18.0506 7.14304 18.95 6.03363 18.95Z" stroke="white" strokeWidth="0.964208" strokeLinecap="round" strokeLinejoin="round"/>
                          </svg>
                        </Button>
                      </OverlayTrigger>
                    }
                    <Button onClick={closeInCart} variant='info'>Закрыть</Button>
                  </div>
                </div>
              </>
            }
          </>
        }
      </>
    )

    if( clientWidth > 768 ) return (
      <Modal
        show={in_cart_show}
        onHide={closeInCart}
        dialogClassName={styles.tocart_dialog}
        contentClassName={styles.tocart_content}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className={styles.tocart_title}>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12.5C1 18.8513 6.14873 24 12.5 24C18.8513 24 24 18.8513 24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5Z" fill="black"/>
                <path d="M16.3333 9.94444L11.2222 15.0556L8.66667 12.5M12.5 24C6.14873 24 1 18.8513 1 12.5C1 6.14873 6.14873 1 12.5 1C18.8513 1 24 6.14873 24 12.5C24 18.8513 18.8513 24 12.5 24Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div>Укажите размер и цвет</div>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className={styles.tocart_body}>
          {cart_body}
        </Modal.Body>
      </Modal>
    )
  
    return (
      <Offcanvas
        show={in_cart_show}
        onHide={closeInCart}
        placement="bottom"
        className={styles.tocart_offcanvas}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div className={styles.tocart_title}>
              <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 12.5C1 18.8513 6.14873 24 12.5 24C18.8513 24 24 18.8513 24 12.5C24 6.14873 18.8513 1 12.5 1C6.14873 1 1 6.14873 1 12.5Z" fill="black"/>
                <path d="M16.3333 9.94444L11.2222 15.0556L8.66667 12.5M12.5 24C6.14873 24 1 18.8513 1 12.5C1 6.14873 6.14873 1 12.5 1C18.8513 1 24 6.14873 24 12.5C24 18.8513 18.8513 24 12.5 24Z" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              <div>Укажите размер и цвет</div>
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className={styles.tocart_body}>
          {cart_body}
        </Offcanvas.Body>
      </Offcanvas>
    )
  }
}

Main.propTypes = {
  in_cart_show: PropTypes.bool,
  in_cart: PropTypes.object,
  closeInCart: PropTypes.func,
  clientWidth: PropTypes.number,
  addTocart: PropTypes.func
}